const countDecimals = (value: number): number => {
  if (Math.floor(value) === value) {
    return 0;
  }

  return value.toString().split('.')[1]?.length || 0;
};

export const formatProjectionValueNumberString = (newValue: string): string => {
  if (newValue === '') {
    return '';
  }

  const newValueNumber = Number(newValue);

  const decimalCount = countDecimals(newValueNumber);

  if (decimalCount === 0) {
    return newValueNumber.toFixed(1);
  }

  return newValue;
};
